import { LoadingButton, LoadingButtonProps } from '@components/Buttons/loading';
import { namedComponent } from '@packages/react/lib/named';
import { color, ColorType } from '@packages/style/colors';
import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components';

export interface ContainedButtonProps extends Omit<LoadingButtonProps, 'component' | 'color'> {
    component?: any;
    color?: ColorType;
    background?: ColorType;
    elevation?: any;
}

export const ContainedButton = styled(
    namedComponent<ContainedButtonProps>(
        ({ background, color, children, ...props }) => (
            <LoadingButton variant={'contained'} {...props}>
                {children}
            </LoadingButton>
        ),
        'ContainedButton',
    ),
)<ContainedButtonProps>`
    && {
        background-color: ${color('background')};
        color: ${color('color')};
        ${({ elevation }): any => (elevation ? '' : 'box-shadow: none;')}
        &:hover {
            background-color: ${(props): any => darken(0.1, color('background', 'primary')(props))};
        }
    }
`;

ContainedButton.defaultProps = { background: 'primary', color: '#fff' };
